module.exports = __webpack_public_path__ + "img/6.de593114.jpg";